import React from "react";
const __pages_import_0__ = React.lazy(() => import("/pages/[...all].tsx"));
import __pages_import_1__ from "/pages/index.tsx";
import __pages_import_2__ from "/pages/index/help/index.tsx";
import __pages_import_3__ from "/pages/index/news/index.tsx";

const routes = [{"caseSensitive":false,"path":"*","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_1__),"children":[{"caseSensitive":false,"path":"help","children":[{"caseSensitive":false,"path":"","element":React.createElement(__pages_import_2__)}]},{"caseSensitive":false,"path":"news","children":[{"caseSensitive":false,"path":"","element":React.createElement(__pages_import_3__)}]}]}];

export default routes;